import { create } from 'zustand';
import { ILoginMutationResponse } from '../models';
import { IInviteDetail } from '../../../types';
import { ISignUpForm, ILoginForm } from '../atoms';

interface IOnboardingState {
  surveyData: {
    fleet: any;
    routes: any[];
  };
  fleet: Record<string, any>;
}

interface AuthStore {
  // State
  userData: Record<string, any>;
  authStep: number;
  onboardingData: IOnboardingState;
  authChallengeState: ILoginMutationResponse | null;
  signUpInputs: ISignUpForm;
  loginInputs: ILoginForm;
  loginTokens: { jwt: string; refresh: string } | null;
  inviteDetail: IInviteDetail | null;
  currentAppState: string;

  // Actions
  setUserData: (user: Record<string, any>) => void;
  setAuthStep: (step: number) => void;
  setOnboardingData: (onboarding: IOnboardingState) => void;
  setAuthChallengeState: (challenge: ILoginMutationResponse | null) => void;
  setSignUpInputs: (inputs: Partial<ISignUpForm> & Record<string, any>) => void;
  setLoginInputs: (inputs: ILoginForm) => void;
  setLoginTokens: (tokens: { jwt: string; refresh: string } | null) => void;
  setInviteDetail: (detail: IInviteDetail | null) => void;
  setCurrentAppState: (app: string) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  userData: {},
  authStep: 1,
  onboardingData: {
    surveyData: {
      fleet: null,
      routes: [],
    },
    fleet: {},
  },
  authChallengeState: null,
  signUpInputs: {
    name: '',
    gender: '',
    email: '',
    password: '',
    familyName: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    org_name: '',
    org_trading_name: '',
    registration_country: '',
  },
  loginInputs: {
    username: '',
    password: '',
  },
  loginTokens: {
    jwt: '',
    refresh: '',
  },
  inviteDetail: null,
  currentAppState: 'mobile',

  setUserData: (user) => set({ userData: user }),
  setAuthStep: (step) => set({ authStep: step }),
  setOnboardingData: (onboarding) => set({ onboardingData: onboarding }),
  setAuthChallengeState: (challenge) => set({ authChallengeState: challenge }),
  setSignUpInputs: (inputs) => set({ signUpInputs: inputs as ISignUpForm }),
  setLoginInputs: (inputs) => set({ loginInputs: inputs }),
  setLoginTokens: (tokens) => set({ loginTokens: tokens }),
  setInviteDetail: (detail) => set({ inviteDetail: detail }),
  setCurrentAppState: (app) => set({ currentAppState: app }),
}));
